// Automatically generated based off models.kt
@file:OptIn(ExperimentalSerializationApi::class, InternalSerializationApi::class)
@file:Suppress("UnusedImport", "UNCHECKED_CAST")

package com.ilussobsa

import com.lightningkite.*
import com.lightningkite.Length.Companion.miles
import com.lightningkite.lightningdb.*
import com.lightningkite.lightningserver.files.*
import com.lightningkite.serialization.*
import kotlin.jvm.JvmInline
import kotlin.math.roundToInt
import kotlin.time.Duration.Companion.seconds
import kotlinx.datetime.*
import kotlinx.serialization.Serializable
import kotlinx.serialization.UseContextualSerialization
import kotlin.io.encoding.Base64
import kotlin.io.encoding.ExperimentalEncodingApi
import com.lightningkite.serialization.DataClassPath
import com.lightningkite.serialization.DataClassPathSelf
import com.lightningkite.serialization.SerializableProperty
import kotlin.reflect.*
import kotlinx.serialization.*
import kotlinx.serialization.builtins.*
import kotlinx.serialization.internal.GeneratedSerializer

// Contextual types: kotlinx.datetime.Instant, com.lightningkite.UUID, com.lightningkite.lightningserver.files.ServerFile, kotlinx.datetime.LocalDate
fun prepareBidFields() {
    val props: Array<SerializableProperty<Bid, *>> = arrayOf(Bid__id, Bid_vehicle, Bid_buyer, Bid_price, Bid_at)
    Bid.serializer().properties { props }
}
val <K> DataClassPath<K, Bid>._id: DataClassPath<K, UUID> get() = this[Bid__id]
val <K> DataClassPath<K, Bid>.vehicle: DataClassPath<K, UUID> get() = this[Bid_vehicle]
val <K> DataClassPath<K, Bid>.buyer: DataClassPath<K, UUID> get() = this[Bid_buyer]
val <K> DataClassPath<K, Bid>.price: DataClassPath<K, PriceInDollars> get() = this[Bid_price]
val <K> DataClassPath<K, Bid>.at: DataClassPath<K, Instant> get() = this[Bid_at]
inline val Bid.Companion.path: DataClassPath<Bid, Bid> get() = path<Bid>()


object Bid__id: SerializableProperty<Bid, UUID> {
    override val name: String by lazy { Bid.serializer().descriptor.getElementName(0) }
    override fun get(receiver: Bid): UUID = receiver._id
    override fun setCopy(receiver: Bid, value: UUID) = receiver.copy(_id = value)
    override val serializer: KSerializer<UUID> by lazy { (Bid.serializer() as GeneratedSerializer<*>).childSerializers()[0] as KSerializer<UUID> }
    override val annotations: List<Annotation> by lazy { Bid.serializer().descriptor.getElementAnnotations(0) }
    override val default: UUID = uuid()
    override val defaultCode: String? = "uuid()" 
}
object Bid_vehicle: SerializableProperty<Bid, UUID> {
    override val name: String by lazy { Bid.serializer().descriptor.getElementName(1) }
    override fun get(receiver: Bid): UUID = receiver.vehicle
    override fun setCopy(receiver: Bid, value: UUID) = receiver.copy(vehicle = value)
    override val serializer: KSerializer<UUID> by lazy { (Bid.serializer() as GeneratedSerializer<*>).childSerializers()[1] as KSerializer<UUID> }
    override val annotations: List<Annotation> by lazy { Bid.serializer().descriptor.getElementAnnotations(1) }
}
object Bid_buyer: SerializableProperty<Bid, UUID> {
    override val name: String by lazy { Bid.serializer().descriptor.getElementName(2) }
    override fun get(receiver: Bid): UUID = receiver.buyer
    override fun setCopy(receiver: Bid, value: UUID) = receiver.copy(buyer = value)
    override val serializer: KSerializer<UUID> by lazy { (Bid.serializer() as GeneratedSerializer<*>).childSerializers()[2] as KSerializer<UUID> }
    override val annotations: List<Annotation> by lazy { Bid.serializer().descriptor.getElementAnnotations(2) }
}
object Bid_price: SerializableProperty<Bid, PriceInDollars> {
    override val name: String by lazy { Bid.serializer().descriptor.getElementName(3) }
    override fun get(receiver: Bid): PriceInDollars = receiver.price
    override fun setCopy(receiver: Bid, value: PriceInDollars) = receiver.copy(price = value)
    override val serializer: KSerializer<PriceInDollars> by lazy { (Bid.serializer() as GeneratedSerializer<*>).childSerializers()[3] as KSerializer<PriceInDollars> }
    override val annotations: List<Annotation> by lazy { Bid.serializer().descriptor.getElementAnnotations(3) }
}
object Bid_at: SerializableProperty<Bid, Instant> {
    override val name: String by lazy { Bid.serializer().descriptor.getElementName(4) }
    override fun get(receiver: Bid): Instant = receiver.at
    override fun setCopy(receiver: Bid, value: Instant) = receiver.copy(at = value)
    override val serializer: KSerializer<Instant> by lazy { (Bid.serializer() as GeneratedSerializer<*>).childSerializers()[4] as KSerializer<Instant> }
    override val annotations: List<Annotation> by lazy { Bid.serializer().descriptor.getElementAnnotations(4) }
    override val default: Instant = now()
    override val defaultCode: String? = "now()" 
}
